/** Format a number with 2 decimal places and comma separators */
export function fmt(n: number): string {
  return n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Format a number as an integer with comma separators */
export function fmtInt(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

/** Format as a dollar amount with 2 decimals */
export function fmtDollar(n: number): string {
  const abs = Math.abs(n);
  return (n < 0 ? '-$' : '$') + fmt(abs);
}

/** Format as a dollar amount (integer) */
export function fmtDollarInt(n: number): string {
  const abs = Math.abs(n);
  return (n < 0 ? '-$' : '$') + fmtInt(abs);
}
